<template>
  <!-- make sure if input exist -->
  <div v-if="input && input.type !== 'none'">
    <!-- <pre>{{input}}</pre> -->

    <template v-if="input.type === 'textfield'">
      <TextField
        @inputUpdate="inputchange"
        :input="input"
        :collaboratorid="collaboratorid"
        :collaborationkey="collaborationkey"
        :answerid="answerid"
        :path="path"
      ></TextField>
    </template>

    <template v-if="input.type === 'textarea'">
      <TextArea
        @inputUpdate="inputchange"
        :input="input"
        :collaboratorid="collaboratorid"
        :collaborationkey="collaborationkey"
        :answerid="answerid"
        :path="path"
      ></TextArea>
    </template>

    <template v-if="input.type === 'legend'">
      <Legend
        @inputUpdate="inputchange"
        :input="input"
        :collaboratorid="collaboratorid"
        :collaborationkey="collaborationkey"
        :answerid="answerid"
        :path="path"
      ></Legend>
    </template>

    <template v-if="input.type === 'checkbox'">
      <CheckBox
        @inputUpdate="inputchange"
        :input="input"
        :collaboratorid="collaboratorid"
        :collaborationkey="collaborationkey"
        :answerid="answerid"
        :path="path"
      ></CheckBox>
    </template>

    <template v-if="input.type === 'upload'">
      <Upload
        @inputUpdate="inputchange"
        :input="input"
        :collaboratorid="collaboratorid"
        :collaborationkey="collaborationkey"
        :answerid="answerid"
        :path="path"
      ></Upload>
    </template>

    <template v-if="Array.isArray(input) && input[0] && input[0].type.indexOf('pulldown') > -1">
      <PullDown
        @inputUpdate="inputchange"
        :input="input"
        :collaboratorid="collaboratorid"
        :collaborationkey="collaborationkey"
        :answerid="answerid"
        :path="path"
      ></PullDown>
    </template>

    <template v-if="Array.isArray(input) && input[0] && input[0].type.indexOf('radio') > -1">
      <Radio
        @inputUpdate="inputchange"
        :input="input"
        :collaboratorid="collaboratorid"
        :collaborationkey="collaborationkey"
        :answerid="answerid"
        :path="path"
      ></Radio>
    </template>

  </div>
</template>

<script>
import TextField from '@/components/audits/delegate/inputs/TextField'
import TextArea from '@/components/audits/delegate/inputs/TextArea'
import Legend from '@/components/audits/delegate/inputs/Legend'
import CheckBox from '@/components/audits/delegate/inputs/CheckBox'
import Upload from '@/components/audits/delegate/inputs/Upload'
import Radio from '@/components/audits/delegate/inputs/Radio'
import PullDown from '@/components/audits/delegate/inputs/PullDown'
import { randomBaseUrl } from '@/js/utils/randomBaseUrl'

export default {
  props: {
    input: Array | Object,
    collaboratorid: String,
    collaborationkey: String,
    answerid: String,
    path: String
  },

  components: {
    TextField: TextField,
    TextArea: TextArea,
    Legend: Legend,
    CheckBox: CheckBox,
    Upload: Upload,
    Radio: Radio,
    PullDown: PullDown
  },

  methods: {
    inputchange () { this.$emit('inputUpdated') }
  },

  created () {
    // if (!this.$store.getters['auth/isAuthenticated']) return
    // init the encoded responses with exception input
    if (this.input.answer && this.input.type &&
        this.input.type !== 'upload' &&
        this.input.type !== 'radio' &&
        this.input.type !== 'pulldown' &&
        this.input.type !== undefined &&
        this.input.type !== 'undefined') this.value = this.input.answer ? this.input.answer : ''

    // init upload input value if encoded answer exist
    if (this.input.type === 'upload' &&
        this.input.answer !== '' &&
        this.input.answer !== undefined &&
        this.input.answer !== 'undefined' &&
        this.input.answer !== null &&
        this.input.answer !== 'null' &&
        this.input.answer !== [] &&
        this.answerid) {
      const img = `${randomBaseUrl(0, 3)}${process.env.VUE_APP_DELEGATE_GET_FILE_SURVEY_ENDPOINT}?valid=${encodeURIComponent(this.$store.state.auth.token)}&answerid=${encodeURIComponent(this.answerid)}&moduleid=${this.input.id}`
      this.img = img
    }// init upload input value if encoded answer exist

    // if it's radio or pulldown
    if (Array.isArray(this.input) && this.input[0]) {
      // if radio group
      if (this.input[0].type.indexOf('radio') > -1 ||
          this.input[0].type.indexOf('pulldown') > -1) {
        this.input.forEach(el => {
          if (el.answer !== '' &&
              el.answer !== 'undefined' &&
              el.answer !== undefined &&
              el.answer !== 'null' &&
              el.answer !== null) {
            this.value = el.answer
          }
        })
      }
    }
  }
}
</script>
